/* @flow */
import { ActionTypes } from '../constants/TransactionConstants';
import { dispatcher } from 'lib/Dispatcher';
import Transactions from 'collections/Transactions';
import ActivityAction from 'payments/actions/ActivityActions';
import Transaction from 'entities/Transaction';
import API from 'lib/RemindAPI';

type id = number | string;

const TransactionActions = {
  // $FlowFixMe
  claim(transactionToClaim, args) {
    return transactionToClaim.claim(args).then(transaction => {
      dispatcher.dispatch({
        type: ActionTypes.CLAIM_TRANSACTION,
        transaction,
      });

      return transaction;
    });
  },

  refund(activityId: string, transactionId: string, reason: string = 'requested_by_customer') {
    return API.request(`/payments/transactions/${transactionId}/refund`, 'POST', { reason }).then(() => {
      return ActivityAction.getTransactions(activityId);
    });
  },

  loadTransactions() {
    return Transactions.load().then(transactions => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_TRANSACTIONS,
        transactions,
      });

      return transactions;
    });
  },

  createWithdrawTransaction(activityId: id, accountId: id, amount: number) {
    return Transaction.createWithdrawTransaction(activityId, accountId, amount).then(transaction => {
      dispatcher.dispatch({
        type: ActionTypes.CREATE_ACTIVITY_WITHDRAW_TRANSACTION,
        activityId,
        transaction,
      });

      return transaction;
    });
  },

  pay() {
    return Transaction.createPayment(...arguments).then(transaction => {
      dispatcher.dispatch({
        type: ActionTypes.CREATE_TRANSACTION,
        transaction,
      });

      return transaction;
    });
  },
};

export default TransactionActions;



// WEBPACK FOOTER //
// ./src/payments/actions/TransactionActions.js